import { Box, Breakpoint, useBreakpoint } from '@betty/moonlight';
import FooterLinks from './FooterLinks/FooterLinks';
import FooterPayments from './FooterPayments/FooterPayments';
import FooterRegulations from './FooterRegulations/FooterRegulations';
import PartnershipBanner from './PartnershipBanner/PartnershipBanner';

function Footer() {
  const breakpoint = useBreakpoint();
  const isMobile = breakpoint === Breakpoint.MOBILE;

  const FirstComponent = isMobile ? FooterPayments : FooterRegulations;
  const SecondComponent = isMobile ? FooterRegulations : FooterPayments;

  return (
    <Box
      backgroundColor="primaryBackground"
      padding={{
        desktop: 'space-1000',
        tablet: 'space-1000',
        mobile: 'space-400',
      }}
      paddingTop={{
        desktop: 'space-2000',
        tablet: 'space-2000',
        mobile: 'space-1000',
      }}
    >
      <PartnershipBanner />
      <Box
        gap="space-1000"
        flexDirection={{
          desktop: 'row',
          tablet: 'row',
          mobile: 'column',
        }}
        flexWrap="wrap"
        justifyContent="space-between"
        width="100%"
      >
        <FooterLinks />
        <FirstComponent />
        <SecondComponent />
      </Box>
    </Box>
  );
}

export default Footer;
